import {
  Button2 as Button,
  PlaceholderAssetAlert,
  PlaceholderFilterSearch,
  Text,
} from '@frameio/vapor';
import TEXT from './generated/TEXT/ResultsMessage';
import styles from './ResultsMessage.module.css';

TEXT.DEFINE({
  noResults: {
    /** Title shown when no search results are found */
    title: 'No Results Found',
    /** Description suggesting how to get more results */
    description:
      'Try tweaking your search or clearing filters to see more results.',
    /** Button label to clear all filters */
    buttonLabel: 'Clear All',
  },
  error: {
    /** Title shown when a search error occurs */
    title: 'Something went wrong',
    /** Button label to retry the search */
    buttonLabel: 'Retry',
  },
});

type ResultsMessageProps = {
  onPress: () => void;
  isError?: boolean;
};

export const ResultsMessage = ({ onPress, isError }: ResultsMessageProps) => {
  const Copy = isError ? TEXT.error : TEXT.noResults;
  const ImageComponent = isError ? (
    <PlaceholderAssetAlert />
  ) : (
    <PlaceholderFilterSearch />
  );

  return (
    <div className={styles.container}>
      <div>{ImageComponent}</div>
      <div className={styles.content}>
        <div className={styles.copy}>
          <Text color="primary" variant="header">
            {Copy.title}
          </Text>
          {'description' in Copy && (
            <Text color="tertiary" variant="body">
              {Copy?.description as string}
            </Text>
          )}
        </div>
        <div>
          <Button onPress={onPress}>{Copy.buttonLabel}</Button>
        </div>
      </div>
    </div>
  );
};
